module.exports = __webpack_public_path__ + "static/Changelly-38c9a8a3197eabdcb8f40526093e4c82.png";